import type {
  CacheInvalidationRequest,
  CacheInvalidationResponse,
  CacheStatusListResponse,
} from '@/types/service/cache';

import { baseProtectedApi } from '@/store/baseApi';

export const cacheApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    getCacheStatus: builder.query<CacheStatusListResponse, void>({
      query: () => ({
        url: '/v1/protected/cache/status',
        method: 'GET',
      }),
    }),
    invalidateCache: builder.mutation<CacheInvalidationResponse, CacheInvalidationRequest>({
      query: (data) => ({
        url: '/v1/protected/cache/invalidate',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useGetCacheStatusQuery, useInvalidateCacheMutation } = cacheApi;
